/*
 * @file: configureStore.prod.js
 * @description: Configure/creating redux store with thunk,reducer etc
 * @author: Mohit Kumar
 * */

import { applyMiddleware, createStore, compose } from 'redux';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';
import { routerMiddleware, createReduxHistory } from './historySetup';
import reducers from '../reducers';

export default () => {
    const store = createStore(reducers, compose(applyMiddleware(thunk, routerMiddleware)));
    const persistor = persistStore(store);
    const history = createReduxHistory(store);
    return { persistor, store, history };
};
